import React from 'react';
import { Typography, Button, Stack } from '@mui/material';

interface ButtonType {
  label: string;
  value: string;
  type: string;
}

interface CTAURLContent {
  header?: string | { type: string; text: string };
  body?: string | { type: string; text: string; parameters?: any };
  footer?: string | { type: string; text: string };
  buttons?: ButtonType[];
}

interface CTAURLMessageProps {
  content: CTAURLContent;
}

const CTAURLMessage: React.FC<CTAURLMessageProps> = ({ content }) => {
  const { header, body, footer, buttons } = content;

  const getText = (textContent: string | { type: string; text: string }) =>
    typeof textContent === 'string' ? textContent : textContent?.text || '';

  return (
    <>
      {header && (
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          {getText(header)}
        </Typography>
      )}

      {body && (
        <Typography variant="body1" sx={{ mb: 2, whiteSpace: 'pre-wrap' }}>
          {getText(body)}
        </Typography>
      )}

      {buttons && buttons.length > 0 && (
        <Stack spacing={1}>
          {buttons.map((button, index) => (
            <Button
              key={index}
              variant="outlined"
              size="small"
              sx={{
                textTransform: 'none',
                borderRadius: '20px',
                fontWeight: 500,
                justifyContent: 'flex-start',
              }}
              onClick={() => window.open(button.value, '_blank')}
            >
              {button.label}
            </Button>
          ))}
        </Stack>
      )}

      {footer && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 2, display: 'block', whiteSpace: 'pre-wrap' }}
        >
          {getText(footer)}
        </Typography>
      )}
    </>
  );
};

export default CTAURLMessage;
